import { all, takeLatest, select, put } from 'redux-saga/effects';
import { prop } from 'ramda';
import { ExperienceTypes, ExperienceActions } from './experience.redux';
import { selectExperienceById, selectExperiencesSlugs } from '../contentRegistry';
import { AnalyticsActions, GTMEvents, IntercomEvents } from '../analytics';

function* handleSetCurrentExperienceBySlug({ slug }) {
  const experiencesSlugs = yield select(selectExperiencesSlugs);
  const experienceId = prop(slug, experiencesSlugs);
  yield put(ExperienceActions.setCurrentExperienceId(experienceId));

  if (experienceId) {
    const experience = yield select(selectExperienceById(experienceId));
    yield put(AnalyticsActions.logGTMEvent(GTMEvents.ViewExperiencePage, { experience }));
    yield put(AnalyticsActions.logIntercomEvent(IntercomEvents.ExperienceView, { experience }));
  }
}

export default function* startupSaga() {
  yield all([takeLatest(ExperienceTypes.SET_CURRENT_EXPERIENCE_BY_SLUG, handleSetCurrentExperienceBySlug)]);
}
